import { Icon, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useContext } from "react";
import { useSelector } from "react-redux";
import ActionButton from "../../../components/shared/ActionButton";
import { DialogContext } from "../../../contexts/DialogueContext";
import { RootState } from "../../../slices/Store";
import ProjectVisibilityDialog from "../../projects/dialogs/ProjectVisibilityDialog";
import AddInvalidDataReportDialog from "../AddInvalidDataReportDialog";

// updated
export default function ProjectDetailInvalidDataAndVisibility() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const { openDialog } = useContext(DialogContext);

    const openAddInvalidDataReportDialog = () => {
        openDialog(<AddInvalidDataReportDialog />);
    };

    const openProjectVisibilityDialog = () => {
        openDialog(
            <ProjectVisibilityDialog
                project={projectDetailState.projectDetail}
            />
        );
    };

    const theme = useTheme();
    const isSmallOrDownScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Stack
            direction={isSmallOrDownScreen ? "column" : "row"}
            sx={{ mb: 2 }}
            spacing={1}
        >
            <ActionButton
                onClick={openAddInvalidDataReportDialog}
                icon={<Icon color="warning">flag</Icon>}
                title="ثبت گزارش خطا برای اطلاعات پروژه"
            />

            <ActionButton
                onClick={openProjectVisibilityDialog}
                icon={<Icon color="error">delete</Icon>}
                title="حذف و عدم نمایش در لیست پروژه ها"
            />
        </Stack>
    );
}
